import type { ReactNode } from 'react';

import { Settings2 } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';
import { PopoverClose } from '@nesso/ui/primitives/popover';

import { PopoverTooltipButton } from '@/shared/ui/common/popover-tooltip-button';

interface Props {
    open: boolean;
    disabled: boolean;
    onOpenChange: (open: boolean) => void;
    save: () => void;
    reset: () => void;
    children: ReactNode;
}

export function EditSessionNoteSettingsPopover({
    open,
    onOpenChange,
    disabled,
    save,
    reset,
    children,
}: Props) {
    return (
        <PopoverTooltipButton
            open={open}
            onOpenChange={(nextOpen) => {
                if (!nextOpen) {
                    reset();
                }

                onOpenChange(nextOpen);
            }}
            popoverProps={{ modal: true }}
            tooltipContent={<p>Customize Note</p>}
            tooltipContentProps={{ showArrow: false }}
            popoverContent={
                <>
                    <div className="flex items-center justify-between px-6 pt-5 pb-4">
                        <span className="font-semibold text-lg">Customize Note</span>
                    </div>

                    {children}

                    <div className="flex items-center justify-end gap-2 py-4 px-6">
                        <PopoverClose asChild>
                            <Button variant="outline">Cancel</Button>
                        </PopoverClose>
                        <PopoverClose asChild>
                            <Button onClick={save}>Update</Button>
                        </PopoverClose>
                    </div>
                </>
            }
            popoverContentProps={{
                className: 'w-[22.713125rem] p-0',
                align: 'end',
                sideOffset: 8,
                side: 'bottom',
            }}
            buttonProps={{
                variant: 'outline',
                size: 'icon',
                'aria-label': 'Customize Note',
                disabled,
                className: cn(open && 'bg-accent/50 text-accent-foreground ring-0'),
            }}
        >
            <Settings2 className="w-4 h-4" />
        </PopoverTooltipButton>
    );
}
